exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pt-wrapper{border:1px solid #0bbd9e;border-radius:3px;padding:0;margin-bottom:15px;text-align:center}.pt-wrapper .pt-name{display:block;padding:10px 0;font-size:26px;color:#eee;background:#0bbd9e}.pt-wrapper .pt-sch{margin-top:10px}.pt-wrapper .pt-add{margin:5px 10px;padding-top:5px;border-top:1px solid #aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/printer-view.vue
// module id = 67
// module chunks = 0